import { Popover } from '@hologram-dimension/popover';
import useSimDetails from 'api/sims/useSimDetails';
import { type FC } from 'react';
import { getUserFriendlyBytes } from 'utils/bytes';
import styles from './SimDataUsage.module.css';

interface SimDataUsageProps {
  hologramSimId?: HologramSimId;
}

const SimDataUsage: FC<SimDataUsageProps> = ({ hologramSimId }) => {
  const { simDetails, error, isLoading } = useSimDetails(hologramSimId);
  const { billingPeriodUsage, preflightUsage, activationTime } = simDetails;
  const usage = activationTime ? (billingPeriodUsage ?? 0) : (preflightUsage ?? 0);

  if (error) {
    return null;
  }

  if (isLoading) return 'Loading...';

  return (
    <Popover
      className={styles.popover}
      content={getUserFriendlyBytes(usage, 'bytes')}
      id="byte-count"
    >
      <div className={styles.byteCount}>
        {usage === 0 && <span className={styles.diminished}>—</span>}
        {usage > 0 && getUserFriendlyBytes(usage, 'long', 'decimal')}{' '}
        {!activationTime && <span className={styles.diminished}>of 100 KB</span>}
      </div>
    </Popover>
  );
};

export default SimDataUsage;
